export default __webpack_public_path__ + "static/client3-b8f80222ade8bf34d3f0b9f00fea96e6.jpg";